import { select, put, cancel } from 'redux-saga/effects';
import { fetch, singleFetch } from '../../../_app/middleware/fetch';
import config from '../../../config';

// ACTIONS

export const SET_TAB_VIEW_SETUP_SCHOOL = 'SET_TAB_VIEW_SETUP_SCHOOL';
export const SET_WEBMASTER_EMAIL = 'SET_WEBMASTER_EMAIL';
export const SEND_WEBMASTER_EMAIL = 'SEND_WEBMASTER_EMAIL';
export const TOGGLE_WEBMASTER_SEND_DISABLE = 'TOGGLE_WEBMASTER_SEND_DISABLE';
export const TOGGLE_WEBMASTER_EMAIL_SENT = 'TOGGLE_WEBMASTER_EMAIL_SENT';
export const SET_VERIFIED_SCHOOLS = 'SET_VERIFIED_SCHOOLS';
export const SET_VERIFIED_DISTRICT = 'SET_VERIFIED_DISTRICT';
export const SEND_VERIFIED_SCHOOLS = 'SEND_VERIFIED_SCHOOLS';
export const SCHOOL_SELECTION_ERROR = 'SCHOOL_SELECTION_ERROR';

// ACTION CREATORS

export function setTabViewSetupSchool(tab) {
  return { type: SET_TAB_VIEW_SETUP_SCHOOL, payload: tab };
}

export function setWebmasterEmail(email) {
  return { type: SET_WEBMASTER_EMAIL, payload: email };
}

export function sendWebmasterEmail() {
  return { type: SEND_WEBMASTER_EMAIL };
}

export function toggleWebmasterSendDisable(boolean) {
  return { type: TOGGLE_WEBMASTER_SEND_DISABLE, payload: boolean };
}

export function toggleWebmasterEmailSent(boolean) {
  return { type: TOGGLE_WEBMASTER_EMAIL_SENT, payload: boolean };
}

export function setVerifiedSchools(schools) {
  return { type: SET_VERIFIED_SCHOOLS, payload: schools };
}

export function setVerifiedDistrict(district) {
  return { type: SET_VERIFIED_DISTRICT, payload: district };
}

export function sendVerifiedSchools() {
  return { type: SEND_VERIFIED_SCHOOLS };
}

export function toggleSchoolSelectionError(boolean) {
  return { type: SCHOOL_SELECTION_ERROR, payload: boolean };
}

// SAGAS

const getWebmasterEmail = state => state.setupSchool.webmasterEmail;
const getRegistrationId = state => state.user.registrationId;
// const getRegistrationId = () => 'f108ec7f-49aa-4d41-8033-efb90d09b802'; // TODO: Remove, for local testing only
const getVerifiedDistrict = state => state.setupSchool.verifiedDistrict;
const getVerifiedSchools = state => state.setupSchool.verifiedSchools;

export function* postWebmasterEmail() {
  const webmasterEmail = yield select(getWebmasterEmail);
  const registrationId = yield select(getRegistrationId);
  const action = {
    data: { recipientEmail: webmasterEmail },
    method: 'post',
    url: `${
      config.REACT_APP_API_BASE_URL
    }/districts/onboarding/${registrationId}/send-to-webmaster`,
  };

  try {
    yield singleFetch(action);
    // TODO: call apolloclient mutate to update the status
  } catch (exception) {
    console.error('postWebmasterEmail exception', exception);
    yield cancel();
  }
}

export function* validateEmail() {
  const webmasterEmail = yield select(getWebmasterEmail);
  const validEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isEmailValid = (email, regex) => regex.test(email);
  const toggle = isEmailValid(webmasterEmail, validEmailRegex);

  if (toggle) {
    yield put({ type: TOGGLE_WEBMASTER_SEND_DISABLE, payload: false });
  }
  if (!toggle) {
    yield put({ type: TOGGLE_WEBMASTER_SEND_DISABLE, payload: true });
  }
}

export function* postVerifiedSchools() {
  const verifiedDistrict = yield select(getVerifiedDistrict);
  const verifiedSchools = yield select(getVerifiedSchools);
  const registrationId = yield select(getRegistrationId);

  const postReadyVerifiedSchools = verifiedSchools.map(school => {
    const { __typename, ...postReadySchool } = school;
    return postReadySchool;
  });

  const postData = Object.assign(verifiedDistrict, {
    schools: postReadyVerifiedSchools,
  });

  const action = {
    data: postData,
    method: 'post',
    url: `${
      config.REACT_APP_API_BASE_URL
    }/districts/onboarding/${registrationId}/create-district-schools`,
  };

  const response = yield fetch(action);
}

// SETUP REDUCER

const initialState = {
  tabViewSetupSchool: 1,
  webmasterEmail: '',
  webmasterSendDisable: true,
  webmasterEmailSent: false,
  verifiedDistrict: {},
  verifiedSchools: [],
  schoolSelectionError: false,
};

export const setupSchoolReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_WEBMASTER_EMAIL:
      return {
        ...state,
        webmasterEmail: action.payload,
      };

    case TOGGLE_WEBMASTER_SEND_DISABLE:
      return {
        ...state,
        webmasterSendDisable: action.payload,
      };

    case TOGGLE_WEBMASTER_EMAIL_SENT:
      return {
        ...state,
        webmasterEmailSent: action.payload,
      };

    case SET_TAB_VIEW_SETUP_SCHOOL:
      return {
        ...state,
        tabViewSetupSchool: action.payload,
      };

    case SET_VERIFIED_SCHOOLS:
      return {
        ...state,
        verifiedSchools: action.payload,
      };

    case SET_VERIFIED_DISTRICT:
      return {
        ...state,
        verifiedDistrict: action.payload,
      };

    case SCHOOL_SELECTION_ERROR:
      return {
        ...state,
        schoolSelectionError: action.payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/school/setup-school.duck.js